import React, { Component } from 'react';
import PropTypes from 'prop-types';

class OutsideClickWatcher extends Component {

    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            const {handleClickOutside, stopPropagation, preventDefault} = this.props;
            if (stopPropagation) event.stopPropagation();
            if (preventDefault) event.preventDefault();

            handleClickOutside(event);
        }
    }

    render() {
        const {children} = this.props;
        return <div ref={this.setWrapperRef}>{children}</div>;
    }
}

OutsideClickWatcher.propTypes = {
    children: PropTypes.any,
    handleClickOutside: PropTypes.func,
    stopPropagation: PropTypes.bool,
    preventDefault: PropTypes.bool,
};

OutsideClickWatcher.defaultProps = {
    children: '',
    handleClickOutside: () => null,
    stopPropagation: false,
    preventDefault: false
};

export default OutsideClickWatcher;

